export function formatBytes(bytes, decimals = 2) {
  const units = [ 'Bytes', 'KB', 'MB', 'GB', 'TB' ];

  let i = 0;
  for (i; bytes > 1024; i++) {
    bytes /= 1024;
  }

  return `${parseFloat(bytes.toFixed(decimals))} ${units[i]}`;
}
